<template>
  <div v-if="userData" class="account-nav-bottom">
    <div>
      <img class="profile-image" :src="profileImage" alt="profile image" />
      <strong class="username text-truncate">{{
        username || userData.id
      }}</strong>
      <p>{{ $t('DASHBOARD.USER_ID') }}: {{ userData.id }}</p>
      <button
        v-tooltip.top-start="{
          content: isAdmin ? 'not allowed as admin' : null,
          hideOnTargetClick: false,
        }"
        :disabled="isAdmin"
        class="link-main icon-link"
        @click="openEditDialog"
      >
        {{ $t('GENERAL.EDIT') }}
      </button>
    </div>
    <router-link
      v-if="displayLogout"
      v-trackClickEvent="{ name: 'logout' }"
      to="/logout"
      class="link-main icon-link logout"
    >
      <Icon icon="logout" /> Logout
    </router-link>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { mapState as mapPiniaState } from 'pinia';
import dialogService from 'commons/dialogs/wrapper/dialogService';
import UserNameAndImageDialog from './UserNameAndImageDialog.vue';
import unsavedChangesService from 'commons/unsavedChangesService/unsavedChangesService';
import { useIdentityStore } from 'commons/stores/identity';
import analyticsService from 'commons/tracking/analytics';

export default {
  name: 'AccountNavBottom',
  components: {},
  props: {
    displayLogout: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapPiniaState(useIdentityStore, ['username']),
    ...mapState({
      userData: (s) => s.user.data,
    }),
    ...mapGetters({
      isAdmin: 'user/isAdmin',
      profileImage: 'user/profileImage',
    }),
  },
  created() {
    if (this.$route.query?.editProfile) {
      this.openEditDialog();
    }
  },
  methods: {
    async openEditDialog() {
      const noUnsavedChanges = await unsavedChangesService.onRouteUpdate(
        {},
        {},
      );
      if (noUnsavedChanges) {
        if (!this.displayLogout) {
          analyticsService.logEvent('showroom_edit_profile_click');
        }
        await dialogService.openDialog(UserNameAndImageDialog);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/constants';
@import 'src/scss/styleguide/type';
@import 'src/scss/utils';

.account-nav-bottom {
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100% !important;

  & > div {
    width: 100%;
    padding: 16px;
    border: 1px solid $grey10;
    border-radius: $border-radius-medium;
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      margin-bottom: 12px;
      text-align: center;
    }

    .username {
      max-width: 100%;
    }
  }
}

.profile-image {
  width: 80px;
  height: 80px;
  border: 1px solid $grey10;
  border-radius: 40px;
  margin: 0 0 8px 0;
}

.logout {
  margin: 16px 0 0 0;
}
</style>
